import React from 'react'
import { Route } from 'react-router-dom'
// import Dashboard from './Dashboard'
import Marketing from './Marketing'
import Fatca from './Fatca'
import Condition from './Condition'
import OnBoardingStage from './OnBoardingStage'
import PersonalInformationForm from './PersonalInformationForm'
import Signature from './Signature'
import Occupation from './Occupation'
import OtherOccuption from './OtherOccuption'
import BusinessType from './BusinessType'
import OtherBusinessType from './OtherBusinessType'
import Salary from './Salary'
import Province from './Province'
import District from './District'
import SubDistrict from './SubDistrict'
import CurrentProvince from './Province/current'
import CurrentDistrict from './District/current'
import CurrentSubDistrict from './SubDistrict/current'
import WorkProvince from './Province/work'
import WorkDistrict from './District/work'
import WorkSubDistrict from './SubDistrict/work'
import DocumentProvince from './Province/document'
import DocumentDistrict from './District/document'
import DocumentSubDistrict from './SubDistrict/document'
import Country from './Country'
import SpouseCountry from './Country/spouse'
import SpouseTitle from './Title/spouse'
import OtherTitle from './OtherTitle'
import Children from './Children'
import FirstChildrenTitle from './Title/firstChildren'
import SecondChildrenTitle from './Title/secondChildren'
import FristChildrenCountry from './Country/fristChildren'
import SecondChildrenCountry from './Country/secondChildren'
import ConfirmEmail from './ConfirmEmail'
import OtpConfirmEmail from './OtpConfirmEmail'
import ConfirmEmailSuccess from './ConfirmEmailSuccess'
import UploadDocument from './UploadDocument'
import HowToIDCard from './HowToIDCard'
import CameraIDCard from './CameraIDCard'
import IDCardLoading from './IDCardLoading'
import HowToBookBank from './HowToBookBank'
import Bank from './Bank'
import CameraBookBank from './CameraBookBank'
import PreviewBookBank from './PreviewBookBank'
import SuitabilityTest from './SuitabilityTest'
import SuitabilityTestResult from './SuitabilityTestResult'


const App = () => {
  return (
    <div>
      <Route exact path="/" component={Marketing} />
      <Route path="/fatca" component={Fatca} />
      <Route path="/condition" component={Condition} />
      <Route path="/on-boarding-stage" component={OnBoardingStage} />
      <Route path="/personal-information-form" component={PersonalInformationForm} />
      <Route path="/signature" component={Signature} />
      <Route path="/select-occ" component={Occupation} />
      <Route path="/select-business-type" component={BusinessType} />
      <Route path="/select-salary" component={Salary} />
      <Route path="/select-province" component={Province} />
      <Route path="/select-district" component={District} />
      <Route path="/select-sub-district" component={SubDistrict} />
      <Route path="/select-current-province" component={CurrentProvince} />
      <Route path="/select-current-district" component={CurrentDistrict} />
      <Route path="/select-current-sub-district" component={CurrentSubDistrict} />
      <Route path="/select-work-province" component={WorkProvince} />
      <Route path="/select-work-district" component={WorkDistrict} />
      <Route path="/select-work-sub-district" component={WorkSubDistrict} />
      <Route path="/select-document-province" component={DocumentProvince} />
      <Route path="/select-document-district" component={DocumentDistrict} />
      <Route path="/select-document-sub-district" component={DocumentSubDistrict} />
      <Route path="/select-country" component={Country} />
      <Route path="/other-occupation" component={OtherOccuption} />
      <Route path="/other-business-type" component={OtherBusinessType} />
      <Route path="/children" component={Children} />
      <Route path="/select-spouse-country" component={SpouseCountry} />
      <Route path="/select-spouse-title" component={SpouseTitle} />
      <Route path="/other-title" component={OtherTitle} />
      <Route path="/select-first-children-title" component={FirstChildrenTitle} />
      <Route path="/select-second-children-title" component={SecondChildrenTitle} />
      <Route path="/select-first-children-country" component={FristChildrenCountry} />
      <Route path="/select-second-children-country" component={SecondChildrenCountry} />
      <Route path="/confirm-email" component={ConfirmEmail} />
      <Route path="/otp-confirm-email" component={OtpConfirmEmail} />
      <Route path="/confirm-email-success" component={ConfirmEmailSuccess} />
      <Route path="/upload-document" component={UploadDocument} />
      <Route path="/how-to-id-card" component={HowToIDCard} />
      <Route path="/camera-id-card" component={CameraIDCard} />
      <Route path="/id-card-loading" component={IDCardLoading} />
      <Route path="/how-to-book-bank" component={HowToBookBank} />
      <Route path="/select-bank" component={Bank} />
      <Route path="/camera-book-bank" component={CameraBookBank} />
      <Route path="/preview-book-bank" component={PreviewBookBank} />
      <Route path="/suitability-test" component={SuitabilityTest} />
      <Route path="/suitability-test-result" component={SuitabilityTestResult} />
    </div>
  )
}

export default App
